import { AfterViewInit, Component } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldProps } from '@ngx-formly/core';

interface EditorProps extends FormlyFieldProps {
  cols?: number;
  rows?: number;
  maxHeight?: string;
  minHeight?: string;
  disabled?: boolean;
  topBard?: boolean;
  activeSlash?: boolean;
  activeBlock?: boolean;
  isActiveTooltip?: boolean;
  topBarItemsConfig?: {};
  isFullHide?: boolean;
  outputFormate?: 'markdown' | 'html' | 'json';
  containerClass?: string[];
  topBarClass?: string[];
}

@Component({
  selector: 'app-formly-field-plain-editor',
  templateUrl: './plain-editor.html',
  styles: [
    `
      :host {
        width: 100%;
      }
    `,
  ],
})
export class FormlyFieldPlainEditorComponent extends FieldType<FieldTypeConfig<EditorProps>> implements AfterViewInit {
  // Editor UI controller
  isTopBard = false;
  isActiveSlash = false;
  isActiveBlock = false;
  value = '';
  isDisabled = false;
  isActiveTooltip = false;
  topBarItemsConfig: any = {};
  outputFormate: 'markdown' | 'html' | 'json' = 'markdown';
  isFullHide = false;
  containerClass: string[] = [];
  topBarClass: string[] = [];

  ngAfterViewInit() {
    this.outputFormate = this.props.outputFormate ?? 'markdown';
    this.isDisabled = this.props.disabled ?? false;
    this.isTopBard = this.props.topBard ?? false;
    this.isActiveSlash = this.props.activeSlash ?? false;
    this.isActiveBlock = this.props.activeBlock ?? false;
    this.isActiveTooltip = this.props.isActiveTooltip ?? false;
    this.isFullHide = this.props.isFullHide ?? false;
    this.topBarItemsConfig = this.props.topBarItemsConfig ?? {};
    this.containerClass = this.props.containerClass ?? [];
    this.topBarClass = this.props.topBarClass ?? [];
    if (this.formControl.defaultValue) {
      this.value = this.formControl.defaultValue;
    } else {
      this.value = ' ';
      if (this.formControl.value) {
        this.value = this.formControl.value;
      }
    }
  }

  editorValue(value: any) {
    // this.value = value;
    this.field.formControl.setValue(value);
  }
}
